
import React, { memo, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown, faChevronCircleUp } from '@fortawesome/free-solid-svg-icons';

import NoEnrollmentMessage from './NoEnrollmentsMessage';
import EnrollmentContainer from './EnrollmentContainer';
import { ConditionalRendering } from '@common-components/conditional-rendering';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';
import { LOGO_URLS } from '../hooks/useEnrollmentHistory';

const StyledContainer = styled.div`
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    min-height: 20px;
    border-radius: 0;
    margin-right: 0px !important;
    box-shadow: none;
`;

const StyledTitleDiv = styled.div`
    font-weight: 600;
    font-family: $font-family-heading;
    img{
        width: 32px;
        margin:8px 8px 8px 0px
    }
`;

interface ICurrentEnrollments {
    activeHealthEnrollments: IEnrollmentDetails[],
    activeDentalEnrollments: IEnrollmentDetails[],
    coverageStartDateForDisenrollment: string,
    coverageYear: string
}

const CurrentEnrollmentContainer = (props: ICurrentEnrollments) => {
    const { activeHealthEnrollments, activeDentalEnrollments, coverageStartDateForDisenrollment, coverageYear } = { ...props };
    const [isShowActiveHealth, setIsShowActiveHealth] = useState(true);
    const [isShowActiveDental, setIsShowActiveDental] = useState(true);
    const hasActiveHealthEnrollments = activeHealthEnrollments.length > 0;
    const hasActiveDentalEnrollments = activeDentalEnrollments.length > 0;
    const hasNoEnrollments = activeHealthEnrollments.length === 0 && activeDentalEnrollments.length === 0;

    return (
        <>
            <ConditionalRendering isTrue={hasActiveHealthEnrollments}>
                <div id="myHealthPlan" className="gi-panel gi-panel__subpanel-gray">
                    <div className='activeEnrollment' data-testid="activeEnrollment">
                        <StyledContainer>
                            <StyledTitleDiv className='collapse-header'>
                                <div data-testid="activeEnrollment-health">
                                    <img src={LOGO_URLS.HEALTH} alt="Medical Plan"></img>
                                    &nbsp;<FormattedMessage id="indportal.enrollments.healthPlan" />
                                </div>
                                <FontAwesomeIcon data-testid='active-health-toggle' icon={isShowActiveHealth ? faChevronCircleUp : faChevronCircleDown} className='accordion-button'
                                    onClick={() => setIsShowActiveHealth(!isShowActiveHealth)} />
                            </StyledTitleDiv>
                            <ConditionalRendering isTrue={isShowActiveHealth}>
                                <div className='enrollment-container'>
                                    <EnrollmentContainer enrollments={activeHealthEnrollments} activeEnrollment='true' coverageStartDateForDisenrollment={coverageStartDateForDisenrollment} coverageYear={coverageYear} />
                                </div>
                            </ConditionalRendering>
                        </StyledContainer>
                    </div>
                </div>
            </ConditionalRendering>
            <ConditionalRendering isTrue={hasActiveDentalEnrollments}>
                <div id="myDentalPlan" className="gi-panel gi-panel__subpanel-gray">
                    <div className='activeEnrollment'>
                        <StyledContainer>
                            <StyledTitleDiv className='collapse-header'>
                                <div data-testid="activeEnrollment-dental">
                                    <img src={LOGO_URLS.DENTAL} alt="Medical Plan"></img>
                                    &nbsp;<FormattedMessage id="indportal.enrollments.dentalPlan" />
                                </div>
                                <FontAwesomeIcon data-testid='active-dental-toggle' icon={isShowActiveDental ? faChevronCircleUp : faChevronCircleDown} className='accordion-button'
                                    onClick={() => setIsShowActiveDental(!isShowActiveDental)} />
                            </StyledTitleDiv>
                            <ConditionalRendering isTrue={isShowActiveDental}>
                                <div className='enrollment-container'>
                                    <EnrollmentContainer enrollments={activeDentalEnrollments} activeEnrollment='true' coverageStartDateForDisenrollment={coverageStartDateForDisenrollment} coverageYear={coverageYear} />
                                </div>
                            </ConditionalRendering>
                        </StyledContainer>
                    </div>
                </div>
            </ConditionalRendering>
            <ConditionalRendering isTrue={hasNoEnrollments}>
                <NoEnrollmentMessage />
            </ConditionalRendering>
        </>
    );
};

export default memo(CurrentEnrollmentContainer);